import { getViewAndUpdatePaymentMethodsCTA } from "./shared";
export var ViewOrUpdatePaymentMethodsIA = function ViewOrUpdatePaymentMethodsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return VIEW_OR_UPDATE_PAYMENT_METHODS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [VIEW_OR_UPDATE_PAYMENT_METHODS_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewAndUpdatePaym;
        return (_getViewAndUpdatePaym = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym === void 0 ? void 0 : _getViewAndUpdatePaym.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewAndUpdatePaym2, _getViewAndUpdatePaym3;
        return (_getViewAndUpdatePaym2 = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym2 === void 0 ? void 0 : (_getViewAndUpdatePaym3 = _getViewAndUpdatePaym2.getLink) === null || _getViewAndUpdatePaym3 === void 0 ? void 0 : _getViewAndUpdatePaym3.call(_getViewAndUpdatePaym2);
      }
    }
  };
};
var VIEW_OR_UPDATE_PAYMENT_METHODS = function VIEW_OR_UPDATE_PAYMENT_METHODS(strictLocalize) {
  return strictLocalize({
    id: "DgA8tP",
    defaultMessage: [{
      "type": 0,
      "value": "Ver ou atualizar formas de pagamento"
    }]
  });
};
var VIEW_OR_UPDATE_PAYMENT_METHODS_EXPLANATION = function VIEW_OR_UPDATE_PAYMENT_METHODS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "j+ZTDQ",
    defaultMessage: [{
      "type": 0,
      "value": "Pode ver ou atualizar as formas de pagamento clicando no botão abaixo. Para referência futura, esta opção está localizada no separador Definições no menu pendente Conta."
    }]
  });
};